/**
 * @generated SignedSource<<54c5de36f8f09a8b79b3f0d46864279b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateVideoElementV2Input = {
  clientMutationId?: string | null | undefined;
  eLearningContentNodeId: string;
  title: string;
  vimeoId: string;
  vimeoVideoSourceId: string;
};
export type CreateVideoElementButton_CreateVideoElementMutation$variables = {
  input: CreateVideoElementV2Input;
};
export type CreateVideoElementButton_CreateVideoElementMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly createVideoElement: {
        readonly eLearningContentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"ContentCard_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type CreateVideoElementButton_CreateVideoElementMutation = {
  response: CreateVideoElementButton_CreateVideoElementMutation$data;
  variables: CreateVideoElementButton_CreateVideoElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vimeoId",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateVideoElementButton_CreateVideoElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CreateVideoElementV2Payload",
                "kind": "LinkedField",
                "name": "createVideoElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "eLearningContentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ContentCard_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateVideoElementButton_CreateVideoElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CreateVideoElementV2Payload",
                "kind": "LinkedField",
                "name": "createVideoElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "eLearningContentNode",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "definitionType",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "elements",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "elementType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isElementV2"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "text",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "TextElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "file",
                                        "plural": false,
                                        "selections": (v4/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "FileElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v5/*: any*/),
                                    "type": "VideoElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "question",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "answeringType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerOptionV2",
                                        "kind": "LinkedField",
                                        "name": "answerOptions",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "answer",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCorrect",
                                            "storageKey": null
                                          },
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MultipleChoiceElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "podcastSource",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sourceType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v5/*: any*/),
                                            "type": "VimeoPodcastSourceV2",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lengthInSeconds",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "podigeeUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "PodigeePodcastSourceV2",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PodcastElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "count",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RandomMultipleChoiceElement",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31e6ceedca19e54ea58823b55301e148",
    "id": null,
    "metadata": {},
    "name": "CreateVideoElementButton_CreateVideoElementMutation",
    "operationKind": "mutation",
    "text": "mutation CreateVideoElementButton_CreateVideoElementMutation(\n  $input: CreateVideoElementV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      createVideoElement(input: $input) {\n        eLearningContentNode {\n          ...ContentCard_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ContentCard_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n  }\n  ...ELearningContentEditor_TreeNodeFragment\n}\n\nfragment ELearningContentEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      elements {\n        __typename\n        id\n        elementType\n        title\n        ...ElementForm_ElementV2Fragment\n      }\n    }\n  }\n}\n\nfragment ElementForm_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  title\n  elementType\n  ... on TextElementV2 {\n    ...TextElementForm_TextElementV2Fragment\n  }\n  ... on FileElementV2 {\n    ...FileElementForm_FileElementV2Fragment\n  }\n  ... on VideoElement {\n    ...VideoElementForm_VideoElementFragment\n  }\n  ... on MultipleChoiceElementV2 {\n    ...MultipleChoiceElementForm_MultipleChoiceElementV2Fragment\n  }\n  ... on PodcastElementV2 {\n    ...PodcastElementForm_PodcastElementV2Fragment\n  }\n  ...ProjectExtendElementForms_ElementV2Fragment\n}\n\nfragment FileElementForm_FileElementV2Fragment on FileElementV2 {\n  id\n  title\n  file {\n    id\n  }\n}\n\nfragment MultipleChoiceElementForm_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  id\n  title\n  question\n  image {\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    isCorrect\n    image {\n      id\n    }\n  }\n}\n\nfragment PodcastElementForm_PodcastElementV2Fragment on PodcastElementV2 {\n  id\n  podcastSource {\n    __typename\n    sourceType\n  }\n  ...VimeoPodcastElementForm_PodcastElementV2Fragment\n  ...PodigeePodcastElementForm_PodcastElementV2Fragment\n}\n\nfragment PodigeePodcastElementForm_PodcastElementV2Fragment on PodcastElementV2 {\n  id\n  title\n  podcastSource {\n    __typename\n    sourceType\n    ... on PodigeePodcastSourceV2 {\n      lengthInSeconds\n      podigeeUrl\n    }\n  }\n}\n\nfragment ProjectExtendElementForms_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  title\n  elementType\n  ...RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment\n}\n\nfragment RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment on RandomMultipleChoiceElement {\n  id\n  count\n}\n\nfragment TextElementForm_TextElementV2Fragment on TextElementV2 {\n  id\n  title\n  text\n}\n\nfragment VideoElementForm_VideoElementFragment on VideoElement {\n  id\n  title\n  vimeoId\n}\n\nfragment VimeoPodcastElementForm_PodcastElementV2Fragment on PodcastElementV2 {\n  id\n  title\n  podcastSource {\n    __typename\n    sourceType\n    ... on VimeoPodcastSourceV2 {\n      sourceType\n      vimeoId\n    }\n    ... on PodigeePodcastSourceV2 {\n      lengthInSeconds\n      podigeeUrl\n    }\n    ... on NoPodcastSourceV2 {\n      sourceType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b4ce3500fe04e1da1dc95ac8a9738d8";

export default node;
